export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'opt' }
  },
  {
    title: that.$l('table_label_shipmentPayStatementNo') || '付款结算单编号',
    field: 'shipmentPayStatementNo',
    width: 180,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_shipmentContractNo') || '外运编号',
    field: 'shipmentContractNo',
    width: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_shipmentNo') || '发运单编号',
    field: 'shipmentNo',
    width: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_customer') || '客户',
    field: 'custName',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_partyType') || '结算方类型',
    field: 'v_payTo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_party') || '结算方',
    field: 'payScmName',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_payer') || '付款方',
    field: 'payerName',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_currencyTotalAmount') || '费用合计',
    field: 'v_currencyTotalAmount',
    width: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_payScmBankName') || '结算方开户银行',
    field: 'payScmBankName',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_payScmBankAccountName') || '结算方账户名称',
    field: 'payScmBankAccountName',
    width: 260,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_payScmBankAccountNo') || '结算方银行账号',
    field: 'payScmBankAccountNo',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_isAppend') || '是否为追加费用',
    field: 'isAppend',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'append' }
  },
  {
    title: that.$l('table_label_remark') || '账单说明',
    field: 'remark',
    minWidth: 350,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  }
]
